import type { IconButtonProps } from '@mui/material';
import { FilterFilledIcon, FilterIcon } from '@src/shared/ui/icons';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from './IconButton';

export interface FilterIconButtonProps extends IconButtonProps {
  isActive?: boolean;
}

const FilterIconButton = forwardRef<HTMLButtonElement, FilterIconButtonProps>(
  ({ isActive = false, ...props }, ref) => {
    const { t } = useTranslation();
    const tooltipTitle = t('common.filter', 'Filter');

    return (
      <IconButton ref={ref} {...props} tooltipTitle={tooltipTitle}>
        {isActive ? (
          <FilterFilledIcon />
        ) : (
          <FilterIcon />
        )}
      </IconButton>
    );
  },
);

FilterIconButton.displayName = 'FilterIconButton';
export default FilterIconButton;
